import { Paper, Typography } from "@mui/material";
import DeviceTypeFilterCard from "./DeviceTypeFilter/DeviceTypeFilterCard";
import DeviceTypeTable from "./DeviceTypeTable/DeviceTypeTable";
import { useEffect, useState } from "react";
import { selectUserData, setIsLoading } from "../../../../features/userSlice";
import { useDispatch } from "react-redux";
import { MetaEntitiesEndPointLogic } from "../../../../logic/Admin/MetaEntities/MetaEntitiesEndPointLogic";
import { useSelector } from "react-redux";
import Page404 from "../../../Page404/Page403";
import { CheckPermissions } from "../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import SimpleBackdrop from "../../../BackDrop/BackDrop";

interface DevicetypeProps {
  oauthTokenHeader: any;
}

const tableHeadings = {
  device_type_name: "Device Type",
  adwords_value: "Adwords Value",
  created: "Created on",
  created_by: "Created By",
  modified: "Last edited",
  modified_by: "Edited By",
};

const DeviceType = ({ oauthTokenHeader }: DevicetypeProps) => {
  const [selecteddeviceType, setSelecteddeviceType] = useState(null);
  const [metaDeviceType, setMetaDeviceType] = useState(null);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const response = useSelector(selectUserData);
  const hasViewDeviceTypePermission = CheckPermissions(
    response?.data?.products?.admin,
    "meta_entities",
    "view_device_types"
  );

  //device type get data
  useEffect(() => {
    const fetchMetaEntitiesDataType = async () => {
      setIsLoading(true);
      setLoading(true);
      try {
        await MetaEntitiesEndPointLogic.getMetaDeviceType(
          oauthTokenHeader,
          dispatch
        );
      } catch (error) {
        console.error("Error fetching Meta Entities:", error);
      } finally {
        setIsLoading(false);
        setLoading(false);
      }
    };
    if (oauthTokenHeader) {
      fetchMetaEntitiesDataType();
    }
  }, [oauthTokenHeader, dispatch]);
  if (!hasViewDeviceTypePermission) {
    return <Page404 />;
  }

  return (
    <>
      {loading ? (
        <SimpleBackdrop />
      ) : (
        <>
          <Paper
            sx={{
              boxShadow: "none",
              padding: "8px 16px 0px",
              borderEndEndRadius: "0px",
              borderBottomLeftRadius: "0px",
            }}
          >
            <Typography fontSize={24}>Device Types List</Typography>
            <DeviceTypeFilterCard />
          </Paper>
          <Paper
            sx={{
              boxShadow: "none",
              borderTopLeftRadius: "0px",
              borderTopRightRadius: "0px",
            }}
          >
            <DeviceTypeTable
              tableHeadings={tableHeadings}
              setMetaDeviceType={setMetaDeviceType}
              oauthTokenHeader={oauthTokenHeader}
              loading={loading}
              metaDeviceType={metaDeviceType}
              selecteddeviceType={selecteddeviceType}
              setSelecteddeviceType={setSelecteddeviceType}
            />
          </Paper>
        </>
      )}
    </>
  );
};

export default DeviceType;
